import { IPayloadAction } from './../scanner/scanner.actions';
import { SessionActions } from './session.actions';
import { ISession } from '../interfaces';
import { UUID } from '../../utilities/uuid';

export function sessionReducer(state: ISession, action: IPayloadAction) {
  switch (action.type) {
    case SessionActions.NEW_SESSION:
      return {
        ...state,
        id: UUID.v4(),
      };

    case SessionActions.SESSIONS_RECEIVED:
      return {
        ...state,
        unsubmitted: action.payload,
      };

    case SessionActions.SESSIONS_FETCH_ERROR:
      return {
        ...state,
        fetchError: action.payload,
      };

    default:
      return state;
  }
}
